export default {
    LO99_BETTING_NOW: "/api/v1.0.0/betting/lotto99",
    FETCH_LO99_DRAWING_RESULT: "/api/v1.0.0/drawing/lotto99",
    FETCH_LO99_RECENT_BET_REPORT: "/api/v1.0.0/reports/recent-betting",
    FETCH_LO99_WIN_LOSS_REPORT: "/api/v1.0.0/reports/lotto99-win-lose",
    FETCH_LO99_STATISTIC: "/api/v1.0.0/drawing/lotto99-statistic",
    FETCH_LO99_RESULT_REPORT: "/api/v1.0.0/drawing/lotto99-lists",
    LO99_FETCH_RECENT_DRAW: "/api/v1.0.0/drawing/lotto99-recent-draw?size=40",
};
